<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items" />
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="name"
                  >Name</label
                >
                <input
                  v-model="search_data.name"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search by Name"
                  id="name"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="nid"
                  >National ID</label
                >
                <input
                  v-model="search_data.nid"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search by National ID"
                  id="nid"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label
                  class="col-form-label col-form-label-sm"
                  for="district_id"
                  >District</label
                >
                <select
                  v-model="search_data.district_id"
                  class="form-control form-control-sm"
                  name="district_id"
                  id="district_id"
                >
                  <option selected :value="''">Select a District</option>
                  <option
                    v-for="(district, index) in districts"
                    :key="index"
                    :value="district.id"
                    >{{ district.id }} : {{ district.district_desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="upazila_id"
                  >Upazila</label
                >
                <select
                  v-model="search_data.upazila_id"
                  class="form-control form-control-sm"
                  name="upazila_id"
                  id="upazila_id"
                >
                  <option selected :value="''">Select a Upazila</option>
                  <option
                    v-for="(upazila, index) in upazilas"
                    :key="index"
                    :value="upazila.id"
                    >{{ upazila.id }} : {{ upazila.upazila_desc }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-row mt-1">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="union_id"
                  >Union</label
                >
                <select
                  v-model="search_data.union_id"
                  class="form-control form-control-sm"
                  name="union_id"
                  id="union_id"
                >
                  <option selected :value="''">Select a Union</option>
                  <option
                    v-for="(union, index) in unions"
                    :key="index"
                    :value="union.id"
                    >{{ union.id }} : {{ union.union_desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="mouza_id"
                  >Mouza</label
                >
                <select
                  v-model="search_data.mouza_id"
                  class="form-control form-control-sm"
                  name="mouza_id"
                  id="mouza_id"
                >
                  <option selected :value="''">Select a Mouza</option>
                  <option
                    v-for="(mouza, index) in mouzas"
                    :key="index"
                    :value="mouza.id"
                    >{{ mouza.id }} : {{ mouza.mouza_desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="village_id"
                  >Village</label
                >
                <select
                  v-model="search_data.village_id"
                  class="form-control form-control-sm"
                  name="village_id"
                  id="village_id"
                >
                  <option selected :value="''">Select a Village</option>
                  <option
                    v-for="(village, index) in villages"
                    :key="index"
                    :value="village.id"
                    >{{ village.id }} : {{ village.village_desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label class="col-form-label col-form-label-sm" for="ep_type_id"
                  >EP type</label
                >
                <select
                  v-model="search_data.ep_type_id"
                  class="form-control form-control-sm"
                  name="ep_type_id"
                  id="ep_type_id"
                >
                  <option selected :value="''">Select a EP type</option>
                  <option
                    v-for="(ep_type, index) in ep_types"
                    :key="index"
                    :value="ep_type.id"
                    >{{ ep_type.id }} : {{ ep_type.ep_type_desc }}</option
                  >
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search"
              >Search</button
            >
          </form>
        </b-card>

        <b-card>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>Form No</th>
                  <th>HH ID</th>
                  <th>Name</th>
                  <th>Father's Name</th>
                  <th>Mouza</th>
                  <th>EP ID</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ses, index) in seses.data" :key="index">
                  <td>{{ seses.from + index }}</td>
                  <td>{{ ses.form_no }}</td>
                  <td>{{ ses.household_number }}</td>
                  <td>
                    <router-link
                      :to="{ name: 'sesView', params: { ses_id: ses.id } }"
                      tag="a"
                      target="_blank"
                      >{{ ses.name }}
                    </router-link>
                  </td>
                  <td>{{ ses.father_husband_name }}</td>
                  <td>{{ ses.mouza.mouza_desc }}</td>
                  <td
                    ><span v-if="ses.ep_id !== null">{{
                      epIdWithPaymentStatus(ses.ep_id.ep_id, ses.ep_id.is_paid)
                    }}</span></td
                  >
                  <td>
                    <span v-if="ses.ep_id !== null">
                      <span v-if="userPermission.includes('ep-id-update')">
                        <!--                                            <a v-if="(ses.ep_id.payment_vouchers.length === 0)"-->
                        <!--                                               @click.prevent="updateEpIdModal(ses.ep_id, ses)" class="action-icon"-->
                        <!--                                               href="javascript:void(0);" title="Update EP ID">-->
                        <!--                                            <i class="mdi mdi-square-edit-outline editButton"></i>-->
                        <!--                                        </a>-->
                      </span>
                    </span>
                    <span v-else>
                      <!-- <span v-if="userPermission.includes('ep-id-create')"> -->
                      <a
                        @click.prevent="addEpIdModal(ses)"
                        class="action-icon"
                        href="javascript:void(0);"
                        title="Create EP ID"
                      >
                        <i class="mdi mdi-plus-box addButton"></i>
                      </a>
                      <!-- </span> -->
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5
              class="text-center text-secondary"
              v-if="seses.total === 0 || !flag"
            >
              No Data Found
            </h5>
            <div class="float-right mt-1">
              <pagination
                :data="seses"
                :limit="2"
                @pagination-change-page="getResults"
              ></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <create-ep-id-modal
      :boxChecked="boxChecked"
      :isPaid="isPaid"
      :ses_ep="ses_ep"
      :example_ep="example_ep"
      :btn_edit="btn_edit"
      @search="search"
    >
    </create-ep-id-modal>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'

import createEpIdModal from '@views/data/modals/createEpIdModal'
import substr_replace from '@views/asset/js/substr_replace'
import { epIdWithPaymentStatus } from '@src/utils/format-epid'

export default {
  page: {
    title: 'SES List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, createEpIdModal },
  data() {
    return {
      title: 'Search SES',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'SES List',
          active: true,
        },
      ],
      seses: {},
      ses_ep: {},
      example_ep: {},
      search_data: {
        name: '',
        nid: '',
        village_id: '',
        mouza_id: '',
        upazila_id: '',
        district_id: '',
        union_id: '',
        ep_type_id: '',
      },
      districts: [],
      all_villages: [],
      all_upazilas: [],
      all_unions: [],
      all_mouzas: [],
      ep_types: [],
      btn_edit: false,
      flag: false,
      loader: false,
      boxChecked: false,
      isPaid: '',
    }
  },

  mounted() {
    this.getCodes()
  },
  methods: {
    epIdWithPaymentStatus: epIdWithPaymentStatus,
    epModify(ep_id) {
      var split_string = ep_id.toString()
      return substr_replace(split_string, '#', 5, 0)
    },
    getCodes() {
      http.get('api/ses/ep-id/codes').then((response) => {
        if (!response.error) {
          let data = response.data
          this.districts = data.districts
          this.all_upazilas = data.upazilas
          this.all_unions = data.unions
          this.all_mouzas = data.mouzas
          this.all_villages = data.villages
          this.ep_types = data.ep_types
        }
      })
    },
    search() {
      this.flag = true
      this.loader = true
      this.$validator.validate().then((valid) => {
        if (valid) {
          http
            .post('api/ses/ep-id/search', this.search_data)
            .then((response) => {
              if (!response.error) {
                this.flag = true
                this.loader = false
                this.seses = response.data.seses
              }
            })
        }
      })
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http
        .post('api/ses/ep-id/search?page=' + page, this.search_data)
        .then((response) => {
          this.flag = true
          this.loader = false
          this.seses = response.data.seses
        })
    },
    addEpIdModal(ses) {
      this.ses_ep = {}
      this.btn_edit = false
      this.ses_ep.ses_id = ses.id
      ;(this.boxChecked = false), (this.isPaid = '')
      var district_id = ses.district.district_geo_code
      var upazila_id = ses.upazila.upazila_geo_code
      var union_id = ses.union.union_geo_code
      var district_form_no = ses.form_no
      var district_form_no_string = district_form_no.toString()
      var form_no = district_form_no_string.slice(1)
      var district = district_id.toString()
      if (district.length === 1) {
        var zero = 0
        district = zero.toString() + district
      }

      var upazila = upazila_id.toString()
      if (upazila.length === 1) {
        var zero = 0
        upazila = zero.toString() + upazila
      }

      var union = union_id.toString()
      if (union.length === 2) {
        var zero = 0
        union = zero.toString() + union
      }

      var ep_id = district + upazila + union + form_no.toString()
      this.ses_ep.ep_id = ep_id

      this.example_ep.district = district
      this.example_ep.district_name = ses.district.district_desc

      this.example_ep.upazila = upazila
      this.example_ep.upazila_name = ses.upazila.upazila_desc

      this.example_ep.union = union
      this.example_ep.union_name = ses.union.union_desc

      this.example_ep.form_no = form_no.toString()

      this.$root.$emit('bv::show::modal', 'create-ep-id')
    },
    updateEpIdModal(ses_ep, ses) {
      // this.ses_ep = {};
      // this.btn_edit = false;
      // this.ses_ep.ses_id = ses.id;
      // var district_id = ses.district_id;
      // var upazila_id = ses.upazila_id;
      // var gender_id = ses.gender_id;
      // var form_no = ses.form_no;
      // var ep_type_id = ses.ep_types[0].id;
      // var upazila = upazila_id.toString();
      // if (upazila.length === 1){
      //     var zero = 0;
      //     upazila = zero.toString() + upazila;
      // }
      //
      // var ep_id = district_id.toString() + upazila + gender_id.toString() + ep_type_id.toString() + form_no.toString();
      //
      // this.ses_ep.id = ses_ep.id;
      // this.ses_ep.ep_id = ep_id;
      // this.$root.$emit("bv::show::modal", "create-ep-id");

      this.btn_edit = true
      this.ses_ep = {}
      http
        .get('api/ses/ep-ids/' + ses_ep.id + '/edit')
        .then((resource) => {
          this.ses_ep = resource.data.ses_ep
        })
        .catch((error) => console.log(error))
      this.$root.$emit('bv::show::modal', 'create-ep-id')
    },
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    },
    upazilas() {
      const district_id = this.search_data.district_id
      return district_id
        ? this.all_upazilas.filter((x) => x.district_id === district_id)
        : null
    },
    unions() {
      const upazila_id = this.search_data.upazila_id
      return upazila_id
        ? this.all_unions.filter((x) => x.upazila_id === upazila_id)
        : null
    },
    mouzas() {
      const union_id = this.search_data.union_id
      return union_id
        ? this.all_mouzas.filter((x) => x.union_id === union_id)
        : null
    },
    villages() {
      const mouza_id = this.search_data.mouza_id
      return mouza_id
        ? this.all_villages.filter((x) => x.mouza_id === mouza_id)
        : null
    },
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
}
</script>
<style src="vue-select/dist/vue-select.css"></style>
